import React, {useCallback, useEffect, useState} from 'react'
import {useParams} from "react-router";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import RouterPath from "libs/RouterPath";
import useSnackbar from "hooks/useSnackbar";
import Tr from "translations/Translations"
import CommissionForm from "components/complex/commissionForm/CommissionForm";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import {simpleConfirm} from "libs/ConfirmNotification";
import CommissionUserType from "constants/CommissionUserType";

function PurchasingGroupStage1Commission(
    {
        panelRef,
        validationSection
    }) {

    const params = useParams();
    const groupId = params.id;
    const formId = params.section;
    const {enqueueSuccessSnackbar} = useSnackbar();
    const [commission, setCommission] = useState({});

    useStepperStateCloseValidator(formId);

    const closeSection = useCallback(() => RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.purchasingGroup.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR, {
        id: groupId,
        stage: 1
    })), [groupId]);

    useEffect(() => {
        PurchasingGroupSectionService.getSections(groupId, validationSection.section)
        PurchasingGroupStage1Service.getCommission(groupId).then((resp) => {
            if (resp)
                setCommission(resp)
            else
                closeSection();
        });
    }, [groupId, closeSection, validationSection.section]);


    const handleSubmit = (values) => {
        PurchasingGroupStage1Service.saveCommission(groupId, values).then(() => {
            enqueueSuccessSnackbar(Tr("saved") + " " + validationSection.name);
            PurchasingGroupSectionService.getSections(groupId, validationSection.section)
            closeSection();
        })
    }

    const doLoadHistory = async () => {
        return await PurchasingGroupStage1Service.getCommissionHistory(groupId);
    }

    const markHistorical = (memberId) => {
        simpleConfirm("archive_commission_member_info", () => PurchasingGroupStage1Service.markHistorical(groupId, memberId).then(resp => {
            if (resp.success && !!commission && !!commission.userListAvailable) {
                const obj = {
                    ...commission,
                    userListAvailable: commission.userListAvailable.filter(x => !(x.userType === CommissionUserType.EXTERNAL_USER && x.id === memberId))
                };
                setCommission(obj);
            }
        }))
    }

    return (
        <CommissionForm
            formId={formId}
            handleSubmit={handleSubmit}
            commissionUserList={commission.commissionUserList}
            userListAvailable={commission.userListAvailable}
            editable={validationSection.editable}
            doLoadHistory={doLoadHistory}
            markHistorical={markHistorical}
        />
    )
}

PurchasingGroupStage1Commission.propTypes = {}

export default PurchasingGroupStage1Commission;